import { render } from "./Team_en_m.vue?vue&type=template&id=765f3905"
import script from "./Team_en_m.vue?vue&type=script&lang=js"
export * from "./Team_en_m.vue?vue&type=script&lang=js"
script.render = render

export default script